<template>
    <div class="idCardExample-container">
        <div class="idCardExample-title">证件上传实例</div>
        <div style="padding: 0.5rem;">
            <img style="width: 100%; height: auto;"
                :src="require(`@/assets/images/expert/${info.type}_eaxmple.png`)"
                alt=""
            />
        </div>
        <div class="idCardExample-floor-btn" @click="doCommit">
            知道了
        </div>
    </div>
  </template>
  <script>
  export default {
    name: "idCardExample",
    props: {
      info: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
      };
    },
    created() {
    },
    methods: {
        doCommit() {
            this.$emit("doComfirm");
        },
    },
  };
  </script>
  <style >
  .idCardExample-container {
    background: #fff;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .idCardExample-title{
    font-size: 1.2rem;
    padding: 0.5rem 0;
  }
  .idCardExample-floor-btn{
    width: 100%;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: var(--el-color-primary);
  }
  </style>
